import { useFragment, graphql } from 'react-relay';
import { useShowSoldPricingGuidance } from './useShowSoldPricingGuidance';

import { useShowSiderailSoldPricingGuidance_viewer$key } from './__generated__/useShowSiderailSoldPricingGuidance_viewer.graphql';
import { useShowSiderailSoldPricingGuidance_item$key } from './__generated__/useShowSiderailSoldPricingGuidance_item.graphql';

const viewerFragment = graphql`
    fragment useShowSiderailSoldPricingGuidance_viewer on Viewer {
        pdpSiderailSoldPricingGuidanceLinkFF: featureFlag(
            feature: "pdpSiderailSoldPricingGuidanceLink"
        )
    }
`;

const itemFragment = graphql`
    fragment useShowSiderailSoldPricingGuidance_item on Item {
        ...useShowSoldPricingGuidance_item
    }
`;

export const useShowSiderailSoldPricingGuidance = ({
    viewer: viewerRef,
    item: itemRef,
    currency,
}: {
    viewer?: useShowSiderailSoldPricingGuidance_viewer$key | null;
    item?: useShowSiderailSoldPricingGuidance_item$key | null;
    currency: string;
}): boolean => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const item = useFragment(itemFragment, itemRef);

    const showSoldPricingGuidance = useShowSoldPricingGuidance({ item, currency });

    return !!viewer?.pdpSiderailSoldPricingGuidanceLinkFF && showSoldPricingGuidance;
};
